var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "600", persistent: true },
      model: {
        value: _vm.dialogIsOpen,
        callback: function($$v) {
          _vm.dialogIsOpen = $$v
        },
        expression: "dialogIsOpen"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "dialog-box home-form-container" },
        [
          _c("h2", { staticClass: "form-title" }, [
            _vm._v(_vm._s(_vm.dialogTitle))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-item mb-4" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("LogicalType")))]),
              _vm._v(" "),
              _c("treeselect", {
                staticClass: "tube-form-input-select",
                attrs: {
                  disableFuzzyMatching: "",
                  options: _vm.fiberTypeOptions,
                  normalizer: _vm.listElementNormalizer
                },
                model: {
                  value: _vm.editedObjectData.logical_type,
                  callback: function($$v) {
                    _vm.$set(_vm.editedObjectData, "logical_type", $$v)
                  },
                  expression: "editedObjectData.logical_type"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-item" }, [
            _c("label", [_vm._v(_vm._s(_vm.$tc("Comment", 1)))]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.editedObjectData.comment,
                  expression: "editedObjectData.comment"
                }
              ],
              attrs: {
                name: "comment",
                id: "comment",
                cols: "30",
                rows: "10",
                maxlength: "1024"
              },
              domProps: { value: _vm.editedObjectData.comment },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.editedObjectData, "comment", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _vm.objectType === "tube"
            ? _c("div", { staticClass: "warning-message-container" }, [
                _c("span", { staticClass: "warning-message" }, [
                  _vm._v("*" + _vm._s(_vm.$t("InsidePlanEditTubeWarning")))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "form-buttons", staticStyle: { padding: "8px 0" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "secondary-button",
                  attrs: { ripple: false, text: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close-form")
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(_vm.$t("Cancel")) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "main-button",
                  attrs: {
                    disabled: !_vm.saveButtonIsDisabled,
                    ripple: false,
                    text: ""
                  },
                  on: { click: _vm.saveObject }
                },
                [_vm._v("\n        " + _vm._s(_vm.$t("Edit")) + "\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce3fee1a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce3fee1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/InsidePlan/forms/EditTubeFiberForm.vue
// module id = null
// module chunks = 